/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IMarcas from 'Infotrack@Modelos/smartStock/marcas/entidades/marcas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import MarcasCM from '../controladorModelo/marcasCM';
import { IFormularioMarcasCVProps } from '../interfaces';
import { acciones, IEstadoMarcas } from '../reductorMarcas';
import FormularioMarcasVista from '../vista/formularioMarcasVista';
import { useSelector } from 'react-redux';

const estadoInicial: IMarcas = {
    EmpresaId: '',
    MarcaDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const marcasCM = new MarcasCM();

const FormularioMarcasCV: React.FunctionComponent<IFormularioMarcasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadMarcas }, dispatch] = useProveedor<IEstadoMarcas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IMarcas>(estadoInicial);

    React.useEffect(() => {
        if (entidadMarcas && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadMarcas);
        } else {
            reiniciar();
        }
    }, [entidadMarcas]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionMarcas = () => {
        if (marcasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarMarcas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarMarcas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            marcasCM
                .crearMarcas({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            marcasCM
                .editarMarcas({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioMarcasVista
            accionCrearEditar={confirmarCreacionEdicionMarcas}
            cambiarInfoFomulario={alCambiarValor}
            marcas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioMarcasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioMarcasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioMarcasCV);
